<template>
	<vdr :w="Number(shu.kuan)" :h="Number(shu.gao)" :x="Number(shu.x)" :y="Number(shu.y)" v-on:dragging="onDrag" v-on:resizing="onResize" :parent="true" :z="Number(shu.z)">
		<div class="Tuodongdaxiao" :style='style'  @contextmenu.prevent="Youji($event)" @click="Zuoji">
			<el-image :style='style' src="https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/iJ1AttVdzuRGdzGZtruuJkcvQjTBRk.jpg"  v-if="shu.leixing=='tu'"></el-image>
			<el-image :style='style' src="https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/iJ1AttVdzuRGdzGZtruuJkcvQjTBRk.jpg"  v-if="shu.leixing=='touxiang'"></el-image>
			<el-image :style='style' src="https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/iJ1AttVdzuRGdzGZtruuJkcvQjTBRk.jpg"  v-if="shu.leixing=='shangpintu'"></el-image>
			<el-image :style='style' src="https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/iJ1AttVdzuRGdzGZtruuJkcvQjTBRk.jpg"  v-else-if="shu.leixing=='erweima'"></el-image>
			<div v-else-if="shu.leixing=='nicheng'">{{shu.nicheng}}</div>
			<div v-else-if="shu.leixing=='tuijianma'">XXXXXXXX</div>
			<div v-else-if="shu.leixing=='shangpinming'">商品名称</div>
			<div v-else-if="shu.leixing=='shangpinjiage'">¥0.00</div>
			<div v-else-if="shu.leixing=='shangpinyuanjia'">¥0.00</div>			
			<slot v-else></slot>
		</div>		
	</vdr>
</template>

<script>
	import vdr from 'vue-draggable-resizable-gorkys'
	import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
	export default {
		name: "tuodongdaxiao",
		components: {
			vdr
		},
		data: function() {
			return {}
		},
		props: {
			shu: {
				type: [Object],
				default () {
					return {
						leixing: "",
						kuan: 100,
						gao: 100,
						z:1,
						nicheng:"nicheng"
					}
				}  
			},
			i:{
				type:Number				
			},
		},
		created() {
			this.style='width:'+this.shu.kuan+'px;height:'+this.shu.gao+'px';		
			this.shu.i=this.i;			
			this.shu.nicheng=this.nicheng;			
		},
		methods: {
			onResize: function(x, y, width, height) {
				this.shu.x = x
				this.shu.y = y
				if (this.shu.leixing == 'erweima') {
					this.shu.kuan = width
					this.shu.gao = width
				} else {
					this.shu.kuan = width
					this.shu.gao = height
				}
				this.style='width:'+this.shu.kuan+'px;height:'+this.shu.gao+'px';
				
			},
			onDrag: function(x, y) {
				this.shu.x = x
				this.shu.y = y
				
			},
			change() {
				// this.$emit('input',this.shu);
			},
			Youji(a,b){		
				this.$emit("Youji",a,this.shu)	
							
			},
			Zuoji(){
				this.$emit("Zuoji",this.shu)
			}
		}
	}
</script>
<style>

</style>
